import type { LPSettlementBatchStatusEnum } from '@talos/kyoko';
import { Icon, Text } from '@talos/kyoko';
import { memo } from 'react';
import type { DefaultTheme } from 'styled-components';
import { getLPBatchStatusMapping } from '../utils/lpBatchStatusMapping';

interface LPBatchStatusRendererProps {
  theme: DefaultTheme;
  status: LPSettlementBatchStatusEnum;
}

export const LPBatchStatusRenderer = memo(({ theme, status }: LPBatchStatusRendererProps) => {
  const statusMapping = getLPBatchStatusMapping(status, theme);

  // If no status mapping, just show the raw status with empty space for icon
  if (!statusMapping) {
    return null;
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      {statusMapping.icon ? (
        <Icon icon={statusMapping.icon} size={16} color={statusMapping.color} />
      ) : (
        <span style={{ width: '12px', display: 'inline-block' }} />
      )}
      <Text>{statusMapping.label}</Text>
    </div>
  );
});

LPBatchStatusRenderer.displayName = 'LPBatchStatusRenderer';
